export default (params) => ({
  trigger: {
    name: 'product_trade_in_overlay.click_on_change',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'product',
          'condition',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'change',
      },
    },
  },
});
